
(function(template){
    define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/categoryFilters',['Vue','vue!basicComponents/radioButton'],function(Vue,radioButton){
        return {
            template:template,
            components: {
                'radio-button' : radioButton
            },
            computed: {
                filters: function(){
                    var vm  = this
                    var Filters = []
                    var showServices = !_.isEmpty(this.$store.state.services) && this.customization.packageBooking.showServices
                    var showPackages = !_.isEmpty(this.$store.state.packages) && this.customization.packageBooking.showPackages
                    if(showServices && showPackages){
                        Filters = ['All']
                        Filters.push(this.localStrings.stepper.body.pick.serviceTitle)
                        Filters.push(this.localStrings.stepper.body.pick.packageTitle)
                    }else if(showServices){
                        this.$store.commit('setSelectedCategoryFilter',{filter:this.localStrings.stepper.body.pick.serviceTitle})
                    }else if(showPackages){
                        this.$store.commit('setSelectedCategoryFilter',{filter:this.localStrings.stepper.body.pick.packageTitle})
                    }
                    return Filters.map(function(filter) {
                        return {name: filter, val: filter}
                    })
                },
                selectedFilter: {
                    get: function(){
                        return this.$store.state.selectedCategoryFilter;
                    },
                    set: function(val){
                        this.$store.commit('setSelectedCategoryFilter',{filter:val})
                    }
                },
                bothSelected: function(){
                    return this.customization.packageBooking.showServices && this.customization.packageBooking.showPackages;
                }
            }
        }
    })
})('<div class="category-filter" role="radiogroup"> <b v-if="bothSelected">{{localStrings.stepper.body.pick.service.details.filterService}}</b> <radio-button :options="filters" :selected.sync="selectedFilter" ></radio-button> </div>');
